function Ambient() {
    return (
        <>
            <div className="aurora" aria-hidden="true">
                <i />
                <i />
            </div>
            <div className="grain" aria-hidden="true" />
        </>
    );
}

export default Ambient;
